var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-spinner-container"}},[_c('img',{staticClass:"mb-2",attrs:{"src":require("@/assets/images/ils-logo-128x144.png"),"alt":"ilovesport.hu"}}),_c('b-spinner',{attrs:{"variant":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }